import { Button, Box, Icon, Paper, useTheme, useMediaQuery, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TableFooter, LinearProgress, Tooltip, Typography, Pagination } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom"
import { useEffect, useState, useMemo } from "react";

import { IUnidade, UnidadeService } from "../../shared/services/api/unidade/UnidadeService";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { Environment } from "../../shared/environment";
import { AlertSnackBar, AutoCompleteDeCliente } from "../../shared/components";
import { IPaginacao } from "../../shared/services/api/axios-config";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";

export const ListagemDeUnidade: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const theme = useTheme();

  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [isLoading, setIsLoading] = useState(false);
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });
  const [rows, setRows] = useState<IUnidade[]>([]);
  const [cnpj, setCnpj] = useState<string | undefined | null>(undefined);

  function resetPaginacao() {
    setPaginacao({
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false
    });
  }

  useEffect(() => {
    handleNewSearch(false);
  }, [cnpj]);

  useEffect(() => {
    handleNewSearch(true);
  }, [pagina]);

  const handleNewSearch = (newPage: boolean) => {
    setIsLoading(true);

    if (cnpj === undefined || cnpj === null || cnpj == '') {
      setIsLoading(false);
      setRows([]);
      setSearchParams({ pagina: "1" }, { replace: true })
      resetPaginacao();
    } else {
      if (newPage) {

        UnidadeService.getByCnpj(pagina, cnpj, true).then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          } else {
            setRows(result.unidades);
            setPaginacao(result.paginacao);
          }
        });

      } else {
        setSearchParams({ pagina: "1" }, { replace: true })
        setRows([]);
        resetPaginacao();
        UnidadeService.getByCnpj(1, cnpj, true).then((result) => {
          setIsLoading(false);

          if (result instanceof Error) {
            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          } else {
            setRows(result.unidades);
            setPaginacao(result.paginacao);
          }
        });
      }
    }


  };


  const handleDelete = () => {
    setAbrir(false);
    setIsLoading(true);
    UnidadeService.toggleEnabledById(idToDelete)
      .then(result => {
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlert({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
        } else {
          setRows(oldRows => {
            return [
              ...oldRows.filter(oldRow => oldRow.idUnidade !== idToDelete),
            ]
          });
          setAlert({ tipoAlert: "sucesso", mensagem: "Área desativada com sucesso" });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);

        }
      });
  }
  const [abrir, setAbrir] = useState(false);
  const [idToDelete, setidToDelete] = useState<number>(0);

  const handleClickDelete = (idUnidade: number) => {
    setAbrir(true);
    setidToDelete(idUnidade);
  };

  const handleCancel = () => {
    setAbrir(false);
  };

  return (
    <LayoutBaseDePagina
      titulo="Listagem de áreas"
      barraDeFerramentas={null}
    >
      <DialogConfirm
        AoConfirmar={handleDelete}
        titulo={"Dejesa realmente desativar a área?"}
        texto={"Ao confirmar, a área e tudo que está contida nela será desativado, para defazer a ação será necessário reativar-la na listagem de área desativada."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      {alert !== undefined && (
        <>
          {alert.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}
      <Box
        component={Paper}
        height={theme.spacing(5)}
        marginX={1}
        padding={1}
        paddingX={2}
        display="flex"
        gap={1}
        alignItems="center"
      >
        <AutoCompleteDeCliente selectedCnpj={selectedCnpj => setCnpj(selectedCnpj)} />

        <Box flex={1} display="flex" justifyContent="end">
          <Button
            color="primary"
            disableElevation
            variant="contained"
            endIcon={<Icon>do_disturb</Icon>}
            onClick={() => navigate('/unidade/desativada')}
          > {smDown ? "" : "Desativadas" }
          </Button>
          
          <Box width={5}></Box>

          {(cnpj === "" || cnpj === null || cnpj === undefined) ?
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>add</Icon>}
              onClick={() => navigate('/unidade/detalhe/nova')}
              disabled
            > {smDown ? "" : "Nova" }
            </Button>
            :
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>add</Icon>}
              onClick={() => navigate('/unidade/detalhe/nova')}
            > {smDown ? "" : "Nova" }
            </Button>
          }

        </Box>
      </Box>

      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> Nome </TableCell>
              <TableCell align="center"> Ações </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {rows.map(row => (
              <TableRow key={row.idUnidade}>
                <TableCell> {row.nomeUnidade} </TableCell>
                <TableCell align="center">

                  <IconButton size="small" onClick={() => navigate(`/unidade/detalhe/${row.idUnidade}`)}>
                    <Tooltip arrow title="Editar área">
                      <Icon> edit </Icon>
                    </Tooltip>
                  </IconButton>

                  <IconButton size="small" onClick={() => handleClickDelete(row.idUnidade)}>
                    <Tooltip arrow title="Desativar área">
                      <Icon> delete </Icon>
                    </Tooltip>
                  </IconButton>

                </TableCell>
              </TableRow>
            ))}

          </TableBody>

          {paginacao.totalCount === 0 && !isLoading && cnpj !== undefined && cnpj !== null && cnpj !== '' && (
            <caption> {Environment.LISTAGEM_VAZIA} </caption>
          )}
          {cnpj === undefined || cnpj === null || cnpj == '' && !isLoading && (
            <caption> Selecione uma unidade para pesquisar </caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={2}>{/* quantas colunas o loading vai ocupar */}
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {paginacao.totalPages > 1 && (
              <TableRow>
                <TableCell colSpan={2} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>

    </LayoutBaseDePagina>
  )
}
